<template>
  <div class="text-center">
    <v-bottom-sheet v-model="sheet" persistent>
      <v-sheet class="text-center" height="420px">
        <div style="padding: 10px 0 10px 0;">
          <v-layout wrap>
            <v-flex xs4 style="text-align: left;padding-left: 20px;padding-top: 10px;">
              <h3 style="font-weight: 400"><b>{{ $t('menuType.selectMenuType', locale) }}</b></h3>
            </v-flex>
            <v-flex xs4 style="padding-top:5px;">
              <search :onSearch="handleSearch" :showOnClear="true" style="width:100%" />
            </v-flex>
            <v-flex xs4 style="text-align: right;padding-right: 10px;">
              <v-btn
                @click="onCloseMenuType(null)"
                color="primary"
              >
                {{ $t('common.close', locale) }}
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <v-layout wrap>
          <v-flex xs12>
            <div 
              v-if="menuTypesFiltered"
              style="width: 100%;padding: 10px 20px;"
            >
              <div
                class="btnMenuType"
                style="float: left;padding: 0;"
                v-for="(item, index) in menuTypesFiltered.filter(x => !x.IsExclusive)"
                :key="`mnu${index}`"
                @click="onCloseMenuType(item.id)"
              >
                  <v-icon style="padding: 5px">{{ item.icon }}</v-icon>
                  <br>
                  <span><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px">{{ $t(`menuType.${item.name}`, locale) }}</h5></span>
              </div>
              <div
                class="btnMenuType"
                style="float: left;padding: 0;"
                v-for="(item, index) in menuTypesFiltered.filter(x => x.IsExclusive)"
                :key="`mnuExclusive${index}`"
                @click="onCloseMenuType(item.id)"
              >
                  <v-icon style="padding: 5px">{{ item.icon }}</v-icon>
                  <br>
                  <span><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px">{{ $t(`menuType.${item.name}`, locale) }}</h5></span>
              </div>
            </div>
          </v-flex>
          <!--v-flex xs12>
            <v-btn
              class="mt-6"          
              color="secundary"
              @click="onCloseMenuType(null)"
            >
            {{ $t('common.cancel', locale) }}
            </v-btn>
          </v-flex-->
        </v-layout>
        <!--table style="margin:auto;" v-if="menuTypes">
          <tr>
            <td
              v-for="(item, index) in menuTypes.filter(x => !x.IsExclusive)"
              :key="`mnu${index}`"
              style="cursor:pointer;padding: 0 1px 0 1px;"
              @click="onCloseMenuType(item.id)"
            >
              <div class="btnMenuType">
                <v-icon style="padding: 5px">{{ item.icon }}</v-icon>
                <br>
                <span><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px">{{ $t(`menuType.${item.name}`, locale) }}</h5></span>
              </div>
            </td>
          </tr>
        </table>
        <table style="margin:auto;" v-if="menuTypes">
          <tr>
            <td
              v-for="(item, index) in menuTypes.filter(x => x.IsExclusive)"
              :key="`mnu${index}`"
              style="cursor:pointer;padding: 0 1px 0 1px;"
              @click="onCloseMenuType(item.id)"
            >
              <div class="btnMenuType">
                <v-icon style="padding: 5px">{{ item.icon }}</v-icon>
                <br>
                <span><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px">{{ $t(`menuType.${item.name}`, locale) }}</h5></span>
              </div>
            </td>
          </tr>
        </table-->
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import constants from '@/constants'
  import Search from '@/components/Search'
  import api from '@/services/api'
  import { METHODS } from 'http'
  export default {
    components: {
      Search,
    },
    props: {
      showMenuType: {
        type: Boolean,
        required: true
      },
      onCloseMenuType: {
        type: Function,
        required: true
      },
      type: {
        type: Number,
        required: false,
        default: null
      },
      isSecundary: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    data: () => ({
      sheet: false,
      selectedMenutype: null,
      menuTypes: null,
      menuTypesFiltered: null,
    }),
    computed: {
      ...mapState('app',['locale']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      isCommonMenus () {
        return this.$route.path.split('/')[1] === 'common-menus' ? true : false
      },
    },
    watch: {
      showMenuType: {
        handler: function (newValue) {
          this.sheet = newValue
        },
        deep: true
      },
      isSecundary:{
        handler: function (newValue) {
          this.getMenuType (this.type, newValue)
          // if (newValue || this.type !== null) {
          //   this.menuTypes = constants.menuType.filter(x => x.id !== 1)
          // } else {
          //   this.menuTypes = constants.menuType
          // }
        },
        deep: true
      },
      type: {
        handler: function (newValue) {
          this.getMenuType (newValue, this.isSecundary)
          // if (newValue !== null || this.isSecundary) {
          //   this.menuTypes = constants.menuType.filter(x => x.id !== 1)
          // } else {
          //   this.menuTypes = constants.menuType
          // }
        },
        deep: true
      }
    },
    mounted () {
      this.getMenuType (this.type, this.isSecundary)
    },
    methods: {
      getMenuType (type, isSecundary) {
        api.getItem('enterprises', false, this.enterpriseID).then(response => {     
          const permission = response.Permission && response.Permission.length > 0 ? JSON.parse(response.Permission) : []    
          if (type !== null || isSecundary) {
            this.menuTypes = constants.menuType.filter(x => x.id !== 1 && (permission.indexOf(x.id) !== -1 || this.isCommonMenus))
          } else {
            this.menuTypes = constants.menuType.filter(x => permission.indexOf(x.id) !== -1 || this.isCommonMenus)
          }
          this.menuTypes = this.menuTypes.map(item => {
            item.tName = this.$t(`menuType.${item.name}`, this.locale)
            return item
          })
          this.handleSearch()
        })
      },
      handleSearch (v) {
        this.menuTypesFiltered = this.menuTypes.filter(x => !v || v.length === 0 || x.name.indexOf(v) >= 0 || x.tName.indexOf(v) >= 0)
      },
    },
  }
</script>

<style scoped>
.btnMenuType {
  margin: 5px;
  padding: 15px 0 15px 0;
  font-weight: normal;
  border-radius: 5px;
  width: 120px;
  border: 1px solid rgb(197, 197, 197);
  min-height: 80px;
  cursor: pointer; 
}
.btnMenuType:hover {
  font-weight: 700;
  background-color: rgba(0, 0, 0, 0.1);
}
</style>

